import { PartnerDashboardCounts, PartnerListItem, PartnerRead } from '../models/partner-management';
import { PartnerScheduleQuery, PartnerScheduleResponse } from '../models/partner-schedule';

export interface PartnerManagementState {
  rows: PartnerListItem[];
  counts: PartnerDashboardCounts;
  totalPartners: number;
  loadingList: boolean;
  loadingDetail: boolean;
  submitting: boolean;
  error: string | null;
  listError: string | null;
  successMessage: string | null;
  selectedPartner: PartnerRead | null;
  selectedPartnerId: string | null;
  schedule: PartnerScheduleResponse | null;
  schedulePartnerId: string | null;
  scheduleQuery: PartnerScheduleQuery | null;
  loadingSchedule: boolean;
  updatingScheduleAvailability: boolean;
  scheduleError: string | null;
  scheduleMutationError: string | null;
  currentPage: number;
  pageSize: number;
}

export const initialPartnerManagementState: PartnerManagementState = {
  rows: [],
  counts: {
    all_partners: 0,
    active_partners: 0,
    inactive_partners: 0,
  },
  totalPartners: 0,
  loadingList: false,
  loadingDetail: false,
  submitting: false,
  error: null,
  listError: null,
  successMessage: null,
  selectedPartner: null,
  selectedPartnerId: null,
  schedule: null,
  schedulePartnerId: null,
  scheduleQuery: null,
  loadingSchedule: false,
  updatingScheduleAvailability: false,
  scheduleError: null,
  scheduleMutationError: null,
  currentPage: 1,
  pageSize: 10,
};
